import { Product } from "../../models";
import { makeActionCreator } from "../../store/types";

export const RELOAD_FEATURED = "product/LOAD_FEATURED";

export const reloadFeatured = makeActionCreator<Product[]>(RELOAD_FEATURED);

export const fetchFeaturedProducts = () => async (dispatch, _, http) => {
  try {
    const result: any = await http.get("data/showcase_products");
    dispatch(reloadFeatured(result.products));
  } catch (error) {
    throw error;
  }
};



// WEBPACK FOOTER //
// ./src/routes/ProductCarousel/actions.ts